import flatpickr from 'flatpickr';
import { Russian } from 'flatpickr/dist/l10n/ru';

const moduleName = 'datepicker';

export function datepicker() {

    Array.from(document.querySelectorAll('.js-datepicker')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const input = self;
        const inputArrow = input.parentNode.querySelector('.entry-arrow');
        const currentDate = new Date();
        const monthBeforeCurrentDate = new Date(Date.now(currentDate) - 1000 * 60 * 60 * 24 * 60);

        if (input.getAttribute('data-datepicker-type') === 'single-date') {

            const datepicker = new flatpickr(input, {
                locale: Russian,
                dateFormat: 'd-m-Y',
                minDate: "today",
                defaultDate: "today",
                onClose: (selectedDates) => {
                    setTimeout(() => {
                        if (!datepicker.input.value) datepicker.setDate(selectedDates);
                        if (typeof dateHistory === 'function') dateHistory();
                    }, 10);
                }
            });

        } else {

            const datepicker = new flatpickr(input, {
                mode: 'range',
                locale: Russian,
                dateFormat: 'd-m-Y',
                defaultDate: [monthBeforeCurrentDate, currentDate],
                onClose: (selectedDates) => {
                    setTimeout(() => {
                        if (!datepicker.input.value) datepicker.setDate(selectedDates);
                        if (typeof dateHistory === 'function') dateHistory();
                    }, 10);
                }
            });

        }


        inputArrow.addEventListener('click', () => {
            datepicker.close();
        });

    });

}